import { createBlockFenceExtension } from '@/components/block-primitives/block-fence-extension';
import { artifactBlockRegistry } from '../artifact-blocks/artifact-block-registry';

export const ArtifactBlockExtension = createBlockFenceExtension({
  nodeName: 'artifactBlock',
  fencePrefix: 'footprint:',
  dataPrefix: 'data-artifact-block',
  registry: artifactBlockRegistry,
  // Investigation's stored fences are single-line today; pretty-printing here would rewrite every
  // block's markdown on its next edit.
  prettyPrintConfig: false,
});
